import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Initialize ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

if($('body').hasClass('background-black')){ 
    document.querySelector('meta[name="theme-color"]').setAttribute('content', '#000000');
} else {
    document.querySelector('meta[name="theme-color"]').setAttribute('content', '#ffffff');
}

$(window).scroll(function() {
    if($('body').hasClass('background-black')){ 
        document.querySelector('meta[name="theme-color"]').setAttribute('content', '#000000');
    } else {
        document.querySelector('meta[name="theme-color"]').setAttribute('content', '#ffffff');
    }
});

if($('.trigger-background-change').length !== 0) {
    $('.trigger-background-change').each(function() {
        const trigger = $(this);
    
        gsap.timeline({
            scrollTrigger: {
                trigger: trigger,
                start: 'bottom bottom',
                endTrigger: 'html',
                end: 'bottom top',
                scrub: 1,
                onToggle: () => {
                    const body = $('body');
                    const footer = $('footer');
    
                    const bodyAddClass = body.hasClass('background-black') ? 'background-default' : 'background-black';
                    const bodyRemoveClass = body.hasClass('background-black') ? 'background-black' : 'background-default';
    
                    const footerAddClass = footer.hasClass('background-secondary') ? 'background-default' : 'background-secondary';
                    const footerRemoveClass = footer.hasClass('background-secondary') ? 'background-secondary' : 'background-default';
    
                    body.removeClass(bodyRemoveClass).addClass(bodyAddClass);
                    footer.removeClass(footerRemoveClass).addClass(footerAddClass);
                    $('.footer__secondary__logo--primary').toggleClass('d-none');
                    $('.footer__secondary__logo--secondary').toggleClass('d-none');
    
                    if (bodyAddClass === 'background-black') {
                        document.querySelector('meta[name="theme-color"]').setAttribute('content', '#000000');
                    } else {
                        document.querySelector('meta[name="theme-color"]').setAttribute('content', '#ffffff');
                    }
                },
            },
        });
    });
}
